export const CHOICE_BRAND_NAME = 'Choice';
export const CHOICE_VIDEO_NAME = `${CHOICE_BRAND_NAME}视讯`;
export const CHOICE_SPORT_NAME = `${CHOICE_BRAND_NAME}体育`;

export const PA_VIDEO_GAME_NAME = 'AG视讯';
export const PA_SPORT_GAME_NAME = 'AG体育';
